module.exports = __webpack_public_path__ + "static/media/mp3-player.5e325eeb.svg";